export * from "@/ui/components/primitives/Spinner/Spinner";
export * from "@/ui/components/primitives/Spinner/Spinner.config";
